import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import {
  CLEAR_FREE_OF_CHARGE_RULE,
  CLEAR_FREE_OF_CHARGE_RULES,
  FLAG_FREE_OF_CHARGE_RULE_ACTIVITY,
  FLAG_GETTING_FREE_OF_CHARGE_RULES,
  GET_FREE_OF_CHARGE_RULE,
  GET_FREE_OF_CHARGE_RULES,
} from '../types';
import { FREE_OF_CHARGE_RULE_ENDPOINT } from '../../config/endpoints';
import { FREE_OF_CHARGE_RULE_PATH } from '../../config/paths';

const flagGettingFreeOfChargeRules = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_FREE_OF_CHARGE_RULES,
    payload: flag,
  });

const getFreeOfChargeRules =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingFreeOfChargeRules(true));
      const query = tableFilters;
      const url = `${FREE_OF_CHARGE_RULE_ENDPOINT}?${QueryString.stringify(
        query,
      )}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const freeOfChargeRules = await response.json();
      dispatch({
        type: GET_FREE_OF_CHARGE_RULES,
        payload: freeOfChargeRules,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingFreeOfChargeRules(false));
    }
  };

const clearFreeOfChargeRules = () => (dispatch) =>
  dispatch({
    type: CLEAR_FREE_OF_CHARGE_RULES,
  });

const clearFreeOfChargeRule = () => (dispatch) =>
  dispatch({
    type: CLEAR_FREE_OF_CHARGE_RULE,
  });

const flagFreeOfChargeRuleActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_FREE_OF_CHARGE_RULE_ACTIVITY,
    payload: flag,
  });

const postFreeOfChargeRule =
  async ({ active, userList }) =>
  async (dispatch) => {
    try {
      dispatch(flagFreeOfChargeRuleActivity(true));

      const payload = {
        active,
        userList,
      };

      const url = FREE_OF_CHARGE_RULE_ENDPOINT;

      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const freeOfChargeRule = await response.json();

      dispatch(push(`${FREE_OF_CHARGE_RULE_PATH}/${freeOfChargeRule.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagFreeOfChargeRuleActivity(false));
    }
  };

const putFreeOfChargeRule =
  async (freeOfChargeRuleId, { active, userList }) =>
  async (dispatch) => {
    try {
      dispatch(flagFreeOfChargeRuleActivity(true));

      const payload = {
        id: freeOfChargeRuleId,
        active,
        userList,
      };

      const url = `${FREE_OF_CHARGE_RULE_ENDPOINT}/${freeOfChargeRuleId}`;

      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const freeOfChargeRule = await response.json();

      dispatch(push(`${FREE_OF_CHARGE_RULE_PATH}/${freeOfChargeRule.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagFreeOfChargeRuleActivity(false));
    }
  };
const getFreeOfChargeRule =
  async ({ freeOfChargeRuleId }) =>
  async (dispatch) => {
    try {
      dispatch(flagFreeOfChargeRuleActivity(true));

      const url = `${FREE_OF_CHARGE_RULE_ENDPOINT}/${freeOfChargeRuleId}`;

      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(response, null, dispatch);

      const freeOfChargeRule = await response.json();

      dispatch({
        type: GET_FREE_OF_CHARGE_RULE,
        payload: freeOfChargeRule,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagFreeOfChargeRuleActivity(false));
    }
  };

const getSingleFreeOfChargeRule = () => async (dispatch) => {
  try {
    dispatch(flagFreeOfChargeRuleActivity(true));

    const url = `${FREE_OF_CHARGE_RULE_ENDPOINT}/single`;

    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

    await isErrorResponse(response, null, dispatch);

    const freeOfChargeRule = await response.json();

    dispatch({
      type: GET_FREE_OF_CHARGE_RULE,
      payload: freeOfChargeRule,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagFreeOfChargeRuleActivity(false));
  }
};

export {
  clearFreeOfChargeRule,
  clearFreeOfChargeRules,
  getFreeOfChargeRule,
  getFreeOfChargeRules,
  postFreeOfChargeRule,
  putFreeOfChargeRule,
  getSingleFreeOfChargeRule,
};
